import {preventDefaultEvent} from '../../../../../../common/shared/utils/preventDefaultEvent.function';
import {twMerge} from '../../../../../../common/twMerge';
import {Image} from '../../../../../../design-system/atoms/Image/Image';

export function ScrollImageViewerImage({
  url,
  aspectRatio,
  gap,
  index,
}: {
  url: string;
  aspectRatio: number;
  gap: boolean;
  index: number;
}) {
  return (
    <div
      key={url}
      className={twMerge('relative w-full', gap && index !== 0 && 'mt-20px')}
      // height는 부모 요소에 상대적이기 때문에 요소 width에 상대적인 padding %를 넣어 주어야 함.
      style={{
        paddingTop: aspectRatio !== 0 ? `${aspectRatio * 100}%` : undefined,
      }}
      data-index={index}
    >
      <div
        className={
          aspectRatio !== 0
            ? 'absolute top-0 h-full w-full overflow-hidden'
            : undefined
        }
      >
        <div
          className={twMerge('h-full w-full', aspectRatio !== 0 && 'absolute')}
        >
          <Image
            className={twMerge(
              'pointer-events-none inset-0 block h-full w-full select-none object-contain',
              aspectRatio !== 0 && 'relative'
            )}
            isLazy={true}
            showFallbackOnError={true}
            ratio={aspectRatio}
            src={url}
            alt=""
            onSelect={preventDefaultEvent}
            onDragStart={preventDefaultEvent}
            onContextMenu={preventDefaultEvent}
          />
        </div>
      </div>
    </div>
  );
}
